const STORAGE_KEY = 'appUpdateAutoRefresh';
const REFRESH_ATTEMPT_KEY = 'appUpdateRefreshAttempt';
const DISMISSED_KEY = 'appUpdateDismissed';

// A "Later" click hides the prompt this long, then it may re-arm — warehouse
// tabs stay open for days, so a session-length dismissal would never expire.
const DISMISS_TTL_MS = 6 * 60 * 60 * 1000;

export function getAppUpdateAutoRefresh() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === null) return true;
    return JSON.parse(saved) !== false;
  } catch (_) {
    return true;
  }
}

export function setAppUpdateAutoRefresh(enabled) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(Boolean(enabled)));
}

/** Stable key for one deployed build as reported by hosting's version.json. */
export function buildUpdateTargetKey({ version, buildId } = {}) {
  return `${String(buildId || 'nobuild')}|${String(version || 'unknown')}`;
}

export function recordUpdateRefreshAttempt(targetKey) {
  if (!targetKey) return;
  try {
    sessionStorage.setItem(REFRESH_ATTEMPT_KEY, JSON.stringify({
      targetKey: String(targetKey),
      at: Date.now(),
    }));
  } catch (_) {
    // ignore quota / private mode
  }
}

export function readUpdateRefreshAttempt() {
  try {
    const raw = sessionStorage.getItem(REFRESH_ATTEMPT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed.targetKey !== 'string') return null;
    return parsed;
  } catch (_) {
    return null;
  }
}

export function clearUpdateRefreshAttempt() {
  try {
    sessionStorage.removeItem(REFRESH_ATTEMPT_KEY);
  } catch (_) {
    // ignore
  }
}

/** True when we already reloaded for this exact target build but are still on the old one. */
export function shouldBlockAutoRefreshLoop(targetKey) {
  if (!targetKey) return false;
  const attempt = readUpdateRefreshAttempt();
  return attempt?.targetKey === String(targetKey);
}

export function setUpdateDismissed(targetKey) {
  if (!targetKey) return;
  try {
    sessionStorage.setItem(DISMISSED_KEY, JSON.stringify({
      targetKey: String(targetKey),
      at: Date.now(),
    }));
  } catch (_) {
    // ignore
  }
}

export function isUpdateDismissed(targetKey) {
  if (!targetKey) return false;
  try {
    const raw = sessionStorage.getItem(DISMISSED_KEY);
    if (!raw) return false;
    const parsed = JSON.parse(raw);
    if (parsed?.targetKey !== String(targetKey)) return false;
    return Date.now() - (parsed.at || 0) < DISMISS_TTL_MS;
  } catch (_) {
    return false;
  }
}
